import script from "./ContactMessagesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactMessagesPage.vue?vue&type=script&setup=true&lang=js"

import "./ContactMessagesPage.vue?vue&type=style&index=0&id=6b4e3b28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b4e3b28"]])

export default __exports__